<template>
  <div>
    <CashClosingDetails :isOpen.sync="cashClosingDetailsPanelOpen" :selectedCashClosing.sync="selectedCashClosing" @updateCashClosings="loadCashClosings" />

    <v-flex xs12>
      <div class="elevation-1 text-center paper mb-1">
        <v-tabs v-model="tab">
          <v-tabs-slider></v-tabs-slider>

          <v-tab class="tab">
            {{ $t('income.cashClosings.title') }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="tabs-items">
          <v-tab-item>
            <div class="d-flex mt-2 flex-column py-4">
              <div class="d-flex justify-space-between">
                <div>
                  <v-item-group v-model="cashClosingTypeTab" mandatory class="switchTabContainer tabs">
                    <v-item v-slot="{ active, toggle }">
                      <div @click="toggle" :class="['switchTab', active ? 'switchTabActive' : '']">
                        {{ $t('income.cashClosings.daily.title') }}
                      </div>
                    </v-item>
                    <v-item v-slot="{ active, toggle }">
                      <div @click="toggle" :class="['switchTab', active ? 'switchTabActive' : '']">
                        {{ $t('income.cashClosings.period.title') }}
                      </div>
                    </v-item>
                  </v-item-group>
                </div>
                <div>
                  <Button v-if="cashClosePermissions['create-cashClose'] && cashClosingTypeTab === 0"
                    size="regular"
                    @click="openCashCLoseDate = true">
                    {{ $t('income.cashClosings.daily.buttonCreate') }}
                  </Button>
                </div>
              </div>

              <!-- // By day -->
              <div v-if="cashClosingTypeTab === 0" class="mt-4">
                <div>
                  <v-data-table
                    :loading-text="tableCashClosings.loadingText"
                    :loading="tableCashClosings.loading"
                    :headers="tableCashClosings.headers"
                    :items="tableCashClosings.data"
                    :options="tableCashClosings.options"
                    :server-items-length="tableCashClosings.total"
                    @update:options="updateTable"
                    :footer-props="{
                      'items-per-page-options': [10, 15, 30]
                    }"
                  >
                    <template v-slot:[`item.cashCloseDate`]="{ item }">
                      <div>
                        <a @click="openCashClosingDetailsPanel(item)" class="link">{{ $moment(item.cashCloseDate).format('dddd') }} - {{ $moment(item.cashCloseDate).format('DD-MM-YYYY')}}</a>
                      </div>
                    </template>
                    <template v-slot:[`item.netSystemSale`]="{ item }">
                      <div>{{ item.netSystemSale | toFix2 | numberWithComma | prefix('$') }}</div>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                      <div :class="item.status === 'unvalidated' ? 'redText' : item.status === 'validated' ? 'greenText' : ''">
                        {{ statusNames(item.status) }}
                      </div>
                    </template>
                    <template v-slot:[`item.totalSaleVerified`]="{ item }">
                      <div>{{ item.totalSaleVerified | toFix2 | numberWithComma | prefix('$') }}</div>
                    </template>
                    <template v-slot:[`item.cancellationByPlatform`]="{ item }">
                      <div>{{ item.cancellationByPlatform | toFix2 | numberWithComma | prefix('$') }}</div>
                    </template>
                    <template v-slot:[`item.cashCloseUpdated`]="{ item }">
                      <div>{{ item.cashCloseUpdated | toFix2 | numberWithComma | prefix('$') }}</div>
                    </template>
                    <template v-slot:[`item.definitiveStatus`]="{ item }">
                      <div :class="item.definitiveStatus === 'unvalidated' ? 'redText' : item.definitiveStatus === 'validated' ? 'greenText' : ''">
                        {{ statusNames(item.definitiveStatus) }}
                      </div>
                    </template>

                    <!-- <template v-slot:footer="">
                      <div class="d-flex footer justify-end mt-1">
                        <div class="footerText">{{ $t('expenses.footerText') }}</div>
                        <div class="my-auto">
                          <v-select
                            v-model="tableCashClosings.options.itemsPerPage"
                            :items="[10, 20, 30, 40, 50]"
                            :append-icon="null"
                            hide-details
                            class="footerSelect" />
                        </div>
                        <div class="my-auto">
                          <v-pagination
                              v-model="tableCashClosings.options.page"
                              :length="pageCount"
                              total-visible="5">
                          </v-pagination>
                        </div>
                      </div>
                    </template> -->
                  </v-data-table>
                </div>
              </div>

              <!-- // By period -->
              <div v-else-if="cashClosingTypeTab === 1">
                <v-dialog @keydown.esc="showCalendarDialog=false" v-model="showCalendarDialog" persistent max-width="400px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" color="primary">Corte por periodo</span>
                    </v-card-title>
                    <v-card-text>
                      <div class="">Selecciona el intervalo en que deseas consultar el periodo de corte.</div>
                      <v-text-field
                        v-model="dateRangeText"
                        :label="`Intervalo de fechas`"
                        prepend-icon="mdi-calendar"
                        readonly
                      ></v-text-field>
                      <div class="d-flex justify-center">
                        <v-date-picker
                          v-model="selectedCalendarDates"
                          ref="picker"
                          color="primary"
                          range
                          :first-day-of-week="1"
                          :allowed-dates="allowedDates"
                          @input="orderDateRange"
                          reactive
                          no-title
                          :locale="locale">
                        </v-date-picker>
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="black darken-1" text @click="onCancelCalendarDialog">Cancelar</v-btn>
                      <v-btn
                        color="primary"
                        depressed
                        @click="onSubmitCalendarDialog">
                        Confirmar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <div v-if="showCalendarDialog == false">
                  <div class="d-flex">
                    <!-- ...izq -->
                    <div class="mt-7 mr-4">
                      <div class="d-flex justify-center align-center">
                        <div class="d-flex flex-column">
                          <img class="calendarIcon" src="@/assets/mdi_calendar-clock.svg" />
                          <span>{{ $t('income.cashClosings.period.initialDate') }}</span>
                          <span>{{ selectedCalendarDates[0] }}</span>
                        </div>
                        <div class="mx-7">
                          <span>-</span>
                        </div>
                        <div class="d-flex flex-column">
                          <img class="calendarIcon" src="@/assets/mdi_calendar-clock.svg" />
                          <span>{{ $t('income.cashClosings.period.finalDate') }}</span>
                          <span>{{ selectedCalendarDates[1] }}</span>
                        </div>
                      </div>
                      <div class="text-center py-7" style="width: 100%;">
                        <Button class="blueButton" size="large" @click="newSearch">
                          <v-icon>mdi-magnify</v-icon>
                          {{ $t('income.cashClosings.period.newSearchButton') }}
                        </Button>
                      </div>
                      <div>
                        <table class="tableGrossSale">
                          <thead>
                            <tr>
                              <th></th>
                              <th></th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody class="amountBox">
                            <tr>
                              <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableNetSale.headers.grossSale') }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr class="subtitle">
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.subtotal') }}</td>
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.tax') }}</td>
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.total') }}</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td class="text-right">{{ (cashClosingsByPeriod.grossSale + cashClosingsByPeriod.discount + cashClosingsByPeriod.cancellations) | toFix2 | numberWithComma | prefix('$') }}</td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableNetSale.headers.netSales') }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr class="subtitle">
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.subtotal') }}</td>
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.tax') }}</td>
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.total') }}</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td class="text-right">{{ cashClosingsByPeriod.grossSale | toFix2 | numberWithComma | prefix('$') }}</td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableNetSale.headers.discounts') }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr class="subtitle">
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.subtotal') }}</td>
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.tax') }}</td>
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.total') }}</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td class="text-right">{{ cashClosingsByPeriod.discount | toFix2 | numberWithComma | prefix('$') }}</td>
                            </tr>
                            <!-- <tr>
                              <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableNetSale.headers.cancelations') }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr class="subtitle">
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.subtotal') }}</td>
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.tax') }}</td>
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.total') }}</td>
                            </tr> -->
                            <tr>
                              <td></td>
                              <td></td>
                              <td class="text-right">{{ cashClosingsByPeriod.cancellations | toFix2 | numberWithComma | prefix('$') }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="mt-6">
                        <table class="tableGrossSale">
                          <thead>
                            <tr>
                              <th></th>
                              <th></th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableNetSale.headers.netSale') }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr class="subtitle">
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.subtotal') }}</td>
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.tax') }}</td>
                              <td>{{ $t('income.cashClosings.period.tableNetSale.headers.total') }}</td>
                            </tr>
                            <tr>
                              <td class="text-right">{{ cashClosingsByPeriod.subtotal | toFix2 | numberWithComma | prefix('$') }}</td>
                              <td class="text-right">{{ cashClosingsByPeriod.iva | toFix2 | numberWithComma | prefix('$') }}</td>
                              <td class="text-right">{{ cashClosingsByPeriod.netSystemSale | toFix2 | numberWithComma | prefix('$') }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <!-- ...der -->
                    <div class="ml-4">
                      <div class="mb-4">
                        <table class="tableCash">
                        <thead>
                          <tr>
                            <th></th>
                            <th class="font-weight-regular header">{{ $t('income.cashClosings.period.tableCash.headers.tips') }}</th>
                            <th class="font-weight-regular header">{{ $t('income.cashClosings.period.tableCash.headers.sale') }}</th>
                            <th class="font-weight-regular header">{{ $t('income.cashClosings.period.tableCash.headers.total') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableCash.headers.netCash') }}</td>
                            <td></td>
                            <td class="text-right">{{ cashClosingsByPeriod.cashSystemSale | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                            <td></td>
                          </tr>
                          <tr v-if="!hasData" style="display: none;"></tr>
                          <tr v-else v-for="incomeType in cashClosingsByPeriod.payments" :key="incomeType.field">
                            <td>{{ incomeType.name }}</td>
                            <td class="text-right">{{ incomeType.tip ? formatCurrency(incomeType.tip) : '--------' }}</td>
                            <td class="text-right">{{ incomeType.amount ? formatCurrency(incomeType.amount) : undefined }}</td>
                            <td class="text-right">{{ incomeType.total ? formatCurrency(incomeType.total) : undefined }}</td>
                          </tr>
                        </tbody>
                          <tfoot>
                            <tr>
                              <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableCash.headers.netSale') }}</td>
                              <td></td>
                              <td class="text-right">
                                <div class="d-flex justify-end">
                                  <span>{{ cashClosingsByPeriod.totalNetSystemSale | toFixNumber(2) | numberWithComma | prefix('$') }}</span>
                                  <v-tooltip v-if="!totalNetSaleMatches" bottom max-width="440px">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="yellow" class="ml-1 alertIcon">mdi-alert</v-icon>
                                    </template>
                                    <span>{{ $t('income.cashClosings.period.tableCash.netSaleTooltip') }}</span>
                                  </v-tooltip>
                                </div>
                              </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableCash.headers.tipsCheck') }}</td>
                              <td class="text-right">{{ cashClosingsByPeriod.byTipTotal | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableCash.headers.tipsCheckHSBC') }}</td>
                              <td class="text-right">{{ cashClosingsByPeriod.tipTotal | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                            <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableCash.headers.realCash') }}</td>
                            <td class="text-right">{{ cashClosingsByPeriod.realCash | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tfoot>
                        </table>
                      </div>
                      <div class="mb-4">
                        <table class="tableTotalCash">
                            <tbody>
                              <tr>
                                <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableTotalCash.headers.cash') }}</td>
                                <td></td>
                                <td class="text-right">
                                  {{ cashClosingsByPeriod.cashCloseUpdated | toFixNumber(2) | numberWithComma | prefix('$') }}
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableTotalCash.headers.cancelations') }}</td>
                                <td></td>
                                <td class="text-right">{{ cashClosingsByPeriod.cancellationByPlatform | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">{{ $t('income.cashClosings.period.tableTotalCash.headers.total') }}</td>
                                <td></td>
                                <td class="text-right">{{ cashClosingsByPeriod.totalSaleVerified | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                                <td></td>
                              </tr>
                            </tbody>
                        </table>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-flex>

    <v-dialog v-model="openCashCLoseDate" persistent max-width="450px">
      <v-card>
        <v-card-title>
          <span class="headline">
            Crear corte en un fecha determinada.
          </span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <div>
                  Utiliza esta opción para crear un corte en una fecha actual o pasada.
                </div>
              </v-col>
              <v-col cols="12">
                <v-date-picker
                  :max="untilToday"
                  v-model="date"
                  no-title
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="close">
            Cerrar
          </v-btn>
          <v-btn
            data-cy="addProduct-success"
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            @click="createCashClosing">
            Crear corte
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'

import CashClosingDetails from '@/components/sidePanels/CashClosingDetails'
import Button from '@/components/elements/Button'
import getLocale from '@/lang/locale'
import formatCurrency from '@/utils/formatCurrency'

export default {
  name: 'CashClosings',
  components: {
    Button,
    CashClosingDetails
  },
  data () {
    return {
      overlay: false,
      section: this.$i18n.t('income.section'),
      tab: null,
      cashClosingTypeTab: null,
      search: null,
      tableCashClosings: {
        loadingText: this.$i18n.t('income.cashClosings.daily.tableCashClosings.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('income.cashClosings.daily.tableCashClosings.headers.date'), value: 'cashCloseDate', sortable: false, align: 'left' },
          { text: this.$i18n.t('income.cashClosings.daily.tableCashClosings.headers.netSale'), value: 'netSystemSale', sortable: false, align: 'center' },
          { text: this.$i18n.t('income.cashClosings.daily.tableCashClosings.headers.dailyCashClosing'), value: 'status', sortable: false, align: 'center' },
          { text: this.$i18n.t('income.cashClosings.daily.tableCashClosings.headers.amount'), value: 'totalSaleVerified', sortable: false, align: 'center' },
          { text: this.$i18n.t('income.cashClosings.daily.tableCashClosings.headers.virtualAmount'), value: 'cancellationByPlatform', sortable: false, align: 'center' },
          { text: this.$i18n.t('income.cashClosings.daily.tableCashClosings.headers.cashClosingWithoutCancelations'), value: 'cashCloseUpdated', sortable: false, align: 'center' },
          { text: this.$i18n.t('income.cashClosings.daily.tableCashClosings.headers.cashClosing'), value: 'definitiveStatus', sortable: false, align: 'center' }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      selectedCashClosing: {},
      cashClosingDetailsPanelOpen: false,
      showCalendarDialog: true,
      selectedCalendarDates: [],
      cashClosingsByPeriod: {},
      openCashCLoseDate: false,
      datePicker: false,
      date: null
    }
  },
  mounted () {
    this.loadCashClosings()
  },
  watch: {
    async restaurant () {
      if (this.restaurant._id) {
        this.resetForm()
        await this.loadCashClosings()
        const [startDate, endDate] = this.selectedCalendarDates
        this.loadCashClosingsByPeriod({
          startDate,
          endDate
        })
      }
    },
    cashClosingTypeTab (value) {
      if (value === 1) {
        this.cashClosingsByPeriod = {}
        this.selectedCalendarDates = []
        this.showCalendarDialog = true
      }
    }
  },
  computed: {
    untilToday () {
      return moment().subtract(1, 'day').format('YYYY-MM-DD')
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    totalRecords () {
      return this.tableCashClosings.data.length
    },
    pageCount () {
      return this.tableCashClosings.options.itemsPerPage ? Math.ceil(this.totalRecords / this.tableCashClosings.options.itemsPerPage) : 0
    },
    dateRangeText () {
      return this.selectedCalendarDates.join(' ~ ')
    },
    locale () {
      return getLocale(this.$i18n.locale)
    },
    hasData: function () {
      return !isEmpty(this.cashClosingsByPeriod.payments)
    },
    totalNetSaleMatches: function () {
      if (isEmpty(this.cashClosingsByPeriod)) {
        return true
      } else {
        let totalNetSaleSum = 0
        this.cashClosingsByPeriod.payments.forEach(payment => {
          totalNetSaleSum += payment.amount
        })

        return this.cashClosingsByPeriod.totalNetSystemSale === totalNetSaleSum
      }
    },
    cashClosePermissions () {
      return this.$store.state.login.permissions['expenses'].components['cash-close'].actions
    }
  },
  methods: {
    resetForm () {
      this.tableCashClosings.data = []
      this.tableCashClosings.total = 0
      this.selectedCashClosing = {}
      this.cashClosingDetailsPanelOpen = false
      this.showCalendarDialog = true
      this.selectedCalendarDates = []
      this.cashClosingsByPeriod = {}
    },
    createCashClosing: async function () {
      const selectedDate = moment(this.date).format('YYYY-MM-DD')
      this.overlay = true
      try {
        await this.$api.post(`/v1/cashClose`, { date: selectedDate })
        await this.loadCashClosings()
        this.close()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async updateTable (data) {
      const { sortBy, sortDesc } = data
      this.tableCashClosings.options.sortDesc = [sortDesc[0]]
      this.tableCashClosings.options.sortBy = [sortBy[0]]
      this.tableCashClosings.options.page = data.page
      await this.loadCashClosings()
    },
    loadCashClosings: async function (params = null) {
      params = params || {
        // restaurant: '5ec1a71158902c5faa23ed93' // dev => comment in prod !
        restaurant: this.restaurant._id, // prod
        limit: this.tableCashClosings.options.itemsPerPage,
        skip: (this.tableCashClosings.options.itemsPerPage * (this.tableCashClosings.options.page - 1))
      }
      this.tableCashClosings.loading = true
      try {
        const response = await this.$api.get(`/v1/cashClose`, params)
        this.tableCashClosings.data = response.data
        this.tableCashClosings.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.tableCashClosings.loading = false
    },
    openCashClosingDetailsPanel (cashClosing) {
      this.selectedCashClosing = { ...cashClosing }
      this.cashClosingDetailsPanelOpen = true
    },
    onCancelCalendarDialog () {
      this.showCalendarDialog = false
    },
    loadCashClosingsByPeriod: async function (params = null) {
      params = {
        // restaurant: '5ec1a71158902c5faa23ed93' // dev => comment in prod !
        restaurant: this.restaurant._id, // prod
        ...params
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashClose`, params)
        this.cashClosingsByPeriod = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    onSubmitCalendarDialog () {
      const [startDate, endDate] = this.selectedCalendarDates
      this.loadCashClosingsByPeriod({
        startDate,
        endDate
      })
      this.showCalendarDialog = false
    },
    allowedDates (val) {
      const nowDate = new Date()
      const evalDate = new Date(moment(val).format('YYYY-MM-DDTHH:mm:ss.SSS'))
      const datesLength = this.selectedCalendarDates.length

      if (datesLength) {
        if (datesLength === 2) {
          return evalDate.getTime() <= nowDate.getTime()
        }
        const selectedDate = new Date(moment(this.selectedCalendarDates[0]).format('YYYY-MM-DDTHH:mm:ss.SSS'))
        const selectedDate2 = new Date(moment(this.selectedCalendarDates[0]).format('YYYY-MM-DDTHH:mm:ss.SSS'))
        const topLimitDate = new Date(selectedDate.setMonth(selectedDate.getMonth() + 1))
        const bottomLimitDate = new Date(selectedDate2.setMonth(selectedDate2.getMonth() - 1))

        return evalDate.getTime() <= nowDate.getTime() &&
          evalDate.getTime() <= topLimitDate.getTime() &&
          evalDate.getTime() >= bottomLimitDate.getTime()
      }

      return evalDate.getTime() <= nowDate.getTime()
    },
    orderDateRange () {
      this.selectedCalendarDates.sort((a, b) => new Date(a) - new Date(b))
    },
    newSearch () {
      this.showCalendarDialog = true
    },
    formatCurrency,
    statusNames (status) {
      return {
        validated: 'Validado',
        unvalidated: 'No validado'
      }[status]
    },
    close () {
      this.openCashCLoseDate = false
      this.datePicker = null
      this.date = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .sectionTitle {
    font-size: 34px;
    font-weight: bold;
    line-height: 40px;
    color: #646464;
  }

  .paper {
    display: flex;
    padding: 40px 50px 50px 57px;
    border-radius: 26px;
    background-color: #fff;
    flex-direction: column;
    align-items: center;
  }

  .tabs {
    &:hover {
      cursor: pointer;
    }
  }

  .tab {
    font-size: 12px;
  }

  .tabs-items {
    width: 100%;
  }

  .switchTabContainer {
    display: flex;
    height: 40px;
    width: fit-content;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);
    border-radius: 25px;
  }

  .switchTab {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 13px 26px;
    border-radius: 25px;
    font-size: 0.857rem;
    color: #9C9C9C;
  }

  .switchTabActive {
    border-radius: 25px;
    background-color: var(--v-primary-base);
    color: #fff;
  }

  .v-pagination__navigation {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .v-pagination__item {
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #A4A6AB !important;
  }

  .v-pagination__item--active {
    color: #fff !important;
  }

  .footer {
    font-size: 12px;
    color: #A4A6AB;
  }

  .footerText {
    margin-right: 12px;
    margin-top: auto;
    margin-bottom: auto;
  }

  .footerSelect {
    width: 30px;
    padding-top: 0px;
    margin-top: 0px;
    color: #A4A6AB;
  }
  .footerSelect.v-text-field>.v-input__control>.v-input__slot:before {
    border-style: none;
  }
  .footerSelect.v-text-field>.v-input__control>.v-input__slot:after {
      border-style: none;
  }

  .footerSelect .v-select__selections {
    color: #A4A6AB !important;
  }

  .link {
    color: #0F6FFF !important;
    &:hover {
      text-decoration: 'underline';
    }
  }

  .redText {
    color: #DA4545;
  }

  .greenText {
    color: #01D28E;
  }

  .tableGrossSale {
    width: 100%;
    border-spacing: 12px;
    border-collapse: collapse;

    & td {
      padding: 6px 35px;
      text-align: left;
    }
  }

  .amountBox {
    background: #F0F0F0;
    border: 1.5px dashed #757575;
  }

  .subtitle {
    font-size: 0.857rem;
    color: #646464;
  }

  .blueButton {
    background-color: #0F6FFF !important;
  }

  .calendarIcon {
    width: 50px;
    align-self: center;
  }

  .content {
    overflow: visible;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .titlePanel {
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
  }

  .tableCash {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px;

    .header {
      font-size: 1.143rem;
    }

    & tr {
      & th {
        padding: 22px 18px;
        background-color: #fff;
      }

      & td {
        padding: 22px 18px;
        background-color: #fff;
        border-top: 1px solid #ACABAB;
        border-bottom: 1px solid #ACABAB;

        &:first-child {
          text-align: left;
          border-top-left-radius: 7px;
          border-bottom-left-radius: 7px;
          border-left: 1px solid #ACABAB;
        }

        &:last-child {
          border-top-right-radius: 7px;
          border-bottom-right-radius: 7px;
          border-right: 1px solid #ACABAB;
        }
      }
    }

    & tfoot tr {
      & td {
        background-color: #f9f9f9;
      }
    }
  }

  .tableTotalCash {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px;

    & tr {
      &:nth-child(odd) td {
        background-color: #f9f9f9;
      }
      &:nth-child(even) td {
        background-color: #EDEDED;
      }
      & td {
        padding: 22px 18px;

        &:first-child {
          text-align: left;
          border-top-left-radius: 7px;
          border-bottom-left-radius: 7px;
        }

        &:last-child {
          border-top-right-radius: 7px;
          border-bottom-right-radius: 7px;
        }
      }
    }
  }

  .alertIcon {
    font-size: 20px;
  }

</style>

<style lang="scss">
  .tableCashClosings th {
    font-size: 12px;
  }

  .tableCashClosings td {
    font-size: 12px;
  }
</style>
